export const categories = [
  { slug: 'wanghong-heiliao', name: '网红黑料', icon: 'ri-user-search-line', count: 1286 },
  { slug: 'mingxing-tafang', name: '明星塌房', icon: 'ri-building-2-line', count: 943 },
  { slug: 'zhibo-chigua', name: '直播吃瓜', icon: 'ri-live-line', count: 756 },
  { slug: 'duanshipin-gua', name: '短视频瓜', icon: 'ri-vidicon-line', count: 632 },
  { slug: 'yule-bagua', name: '娱乐八卦', icon: 'ri-chat-smile-2-line', count: 1102 },
  { slug: 'shejiao-remen', name: '社交热门', icon: 'ri-fire-line', count: 891 },
  { slug: 'meishi-heitie', name: '黑贴实锤', icon: 'ri-hammer-line', count: 567 },
  { slug: 'quanwei-piyao', name: '权威辟谣', icon: 'ri-shield-check-line', count: 334 },
];

export const hotTopics = [
  { id: 1, articleSlug: 'dingliu-wanghong-lu-yin-xie-lou', title: '某顶流网红被爆私下辱骂粉丝录音流出', tag: '网红黑料', heat: '128.6w', image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20studio%20scene%20with%20a%20leaking%20recording%20device%20on%20a%20dark%20desk%2C%20dim%20red%20ambient%20lighting%2C%20cinematic%20noir%20photography%2C%20dramatic%20shadows%2C%20thriller%20atmosphere%2C%20professional%20composition%20with%20shallow%20depth%20of%20field%2C%20dark%20red%20and%20black%20color%20palette&width=400&height=400&seq=hot-topic-01&orientation=squarish' },
  { id: 2, articleSlug: 'zhubo-zhi-bo-jing-tou-yi-wai', title: '知名女主播直播间意外曝光真实颜值', tag: '直播吃瓜', heat: '99.3w', image: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20studio%20setup%20with%20professional%20camera%20and%20monitor%20displaying%20static%2C%20dim%20purple%20and%20red%20LED%20ambient%20lighting%2C%20cinematic%20photography%2C%20mysterious%20mood%2C%20dark%20atmosphere%20with%20equipment%20silhouettes%2C%20noir%20style%20composition&width=400&height=400&seq=hot-topic-02&orientation=squarish' },
  { id: 3, articleSlug: 'qianwan-bozhu-xu-jia-xuan-chuan', title: '千万粉丝博主涉嫌虚假宣传被立案调查', tag: '黑贴实锤', heat: '87.2w', image: 'https://readdy.ai/api/search-image?query=Dark%20legal%20document%20scene%20with%20official%20papers%20spread%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20red%20accent%20lighting%20from%20the%20side%2C%20cinematic%20noir%20photography%2C%20investigation%20atmosphere%2C%20dark%20mood%20with%20selective%20lighting%2C%20professional%20composition&width=400&height=400&seq=hot-topic-03&orientation=squarish' },
  { id: 4, articleSlug: 'nantuan-chengyuan-shenye-yuehui', title: '某男团成员深夜与神秘女子同回公寓', tag: '明星塌房', heat: '76.8w', image: 'https://readdy.ai/api/search-image?query=Dark%20city%20street%20at%20night%20with%20luxury%20apartment%20building%20entrance%2C%20blurred%20figures%20in%20the%20distance%2C%20dramatic%20red%20and%20blue%20neon%20lighting%20reflections%2C%20paparazzi%20style%20cinematic%20photography%2C%20mysterious%20night%20atmosphere%2C%20film%20noir%20aesthetic&width=400&height=400&seq=hot-topic-04&orientation=squarish' },
  { id: 5, articleSlug: 'daweiwang-bozhu-cui-tu-zheng-ju', title: '大胃王博主被曝催吐证据，人设彻底崩塌', tag: '网红黑料', heat: '65.4w', image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20restaurant%20interior%20with%20empty%20plates%20on%20a%20table%2C%20dramatic%20red%20spotlight%20creating%20mysterious%20atmosphere%2C%20cinematic%20photography%20with%20deep%20shadows%2C%20noir%20style%2C%20investigative%20journalism%20mood%2C%20dark%20and%20dramatic%20composition&width=400&height=400&seq=hot-topic-05&orientation=squarish' },
  { id: 6, articleSlug: 'meizhuang-bozhu-shou-jia-ju-bao', title: '知名美妆博主售假被粉丝联合举报', tag: '黑贴实锤', heat: '54.1w', image: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20cosmetics%20products%20scattered%20on%20a%20surface%20with%20red%20caution%20lighting%2C%20mysterious%20dramatic%20atmosphere%2C%20cinematic%20noir%20photography%2C%20consumer%20investigation%20theme%2C%20dark%20shadows%20and%20selective%20red%20accents%2C%20professional%20composition&width=400&height=400&seq=hot-topic-06&orientation=squarish' },
];

export const latestArticles = [
  {
    id: 1,
    slug: 'dingliu-wanghong-lu-yin-xie-lou',
    title: '独家：某千万粉顶流网红私下辱骂粉丝录音全曝光，运营团队连夜道歉',
    excerpt: '近日，一段疑似某知名网红私下辱骂粉丝的录音在网上疯传。该网红拥有超过1200万粉丝，常年以亲切阳光形象示人。录音内容极其恶劣，引发全网热议...',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    views: 1286000,
    comments: 38241,
    time: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20recording%20studio%20scene%20with%20vintage%20microphone%20and%20audio%20equipment%2C%20dramatic%20red%20and%20black%20lighting%2C%20cinematic%20noir%20photography%2C%20investigative%20journalism%20theme%2C%20tense%20atmosphere%2C%20professional%20composition%20with%20deep%20shadows&width=800&height=500&seq=article-cover-01&orientation=landscape',
    featured: true,
    tags: ['录音泄露', '网红人设', '粉丝冲突'],
    author: '吃瓜前线记者',
    content: '',
  },
  {
    id: 2,
    slug: 'zhubo-zhi-bo-jing-tou-yi-wai',
    title: '知名女主播忘记开美颜，直播间30万人围观真实容貌引热议',
    excerpt: '昨晚某知名女主播在直播过程中疑似忘记开启美颜滤镜，真实容貌与平日精修照片差距巨大，直播间瞬间涌入超30万观众围观...',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    views: 993000,
    comments: 25678,
    time: '4小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20room%20with%20multiple%20monitors%20and%20camera%20equipment%2C%20dramatic%20red%20LED%20accents%20in%20darkness%2C%20cinematic%20photography%2C%20mysterious%20streamer%20atmosphere%2C%20professional%20lighting%20setup%2C%20noir%20style%20composition&width=800&height=500&seq=article-cover-02&orientation=landscape',
    featured: true,
    tags: ['美颜翻车', '直播事故', '真实容貌'],
    author: '吃瓜小能手',
    content: '',
  },
  {
    id: 3,
    slug: 'qianwan-bozhu-xu-jia-xuan-chuan',
    title: '千万粉丝博主涉嫌虚假宣传，市场监管局已正式立案调查',
    excerpt: '据知情人士透露，某拥有千万粉丝的知名博主因涉嫌在其直播带货中虚假宣传产品功效，已被当地市场监管局正式立案调查...',
    category: '黑贴实锤',
    categorySlug: 'meishi-heitie',
    views: 872000,
    comments: 19452,
    time: '6小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20official%20document%20scene%20on%20a%20desk%20with%20red%20stamp%20accents%2C%20dramatic%20investigative%20lighting%2C%20cinematic%20noir%20photography%2C%20legal%20atmosphere%20with%20dark%20shadows%2C%20government%20investigation%20theme%2C%20professional%20composition&width=800&height=500&seq=article-cover-03&orientation=landscape',
    featured: true,
    tags: ['虚假宣传', '立案调查', '直播带货'],
    author: '法制吃瓜员',
    content: '',
  },
  {
    id: 4,
    slug: 'nantuan-chengyuan-shenye-yuehui',
    title: '当红男团成员深夜密会神秘女子，粉丝后援会紧急发声明',
    excerpt: '昨晚有媒体拍到某当红男团成员深夜与一名神秘女子共同返回某高档公寓，两人举止亲密。消息曝光后粉丝炸锅，后援会紧急发布声明...',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    views: 768000,
    comments: 42310,
    time: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20city%20night%20street%20scene%20with%20luxury%20apartment%20building%2C%20paparazzi%20style%20cinematic%20photography%2C%20dramatic%20red%20neon%20lighting%2C%20mysterious%20night%20atmosphere%2C%20celebrity%20gossip%20theme%2C%20film%20noir%20aesthetic&width=800&height=500&seq=article-cover-04&orientation=landscape',
    featured: false,
    tags: ['男团恋爱', '粉丝塌房', '公寓密会'],
    author: '八卦速递员',
    content: '',
  },
  {
    id: 5,
    slug: 'daweiwang-bozhu-cui-tu-zheng-ju',
    title: '大胃王博主催吐证据链完整曝光，团队前员工实名举报',
    excerpt: '一位自称曾在大胃王博主团队工作过的人员实名爆料，提供了大量该博主长期催吐的聊天记录和影像证据，引发全网轰动...',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    views: 654000,
    comments: 31200,
    time: '10小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20interior%20with%20empty%20plates%20and%20dramatic%20red%20lighting%2C%20mysterious%20mood%20with%20deep%20shadows%2C%20cinematic%20photography%2C%20whistleblower%20theme%2C%20dark%20atmosphere%2C%20professional%20composition&width=800&height=500&seq=article-cover-05&orientation=landscape',
    featured: false,
    tags: ['催吐证据', '前员工举报', '大胃王造假'],
    author: '食品安全观察员',
    content: '',
  },
  {
    id: 6,
    slug: 'meizhuang-bozhu-shou-jia-ju-bao',
    title: '知名美妆博主售假被超500名粉丝联合举报，涉案金额或达千万',
    excerpt: '近日超500名消费者联合向12315举报某知名美妆博主直播售假，涉及多个大牌化妆品。据初步统计，涉案金额可能高达千万元...',
    category: '黑贴实锤',
    categorySlug: 'meishi-heitie',
    views: 541000,
    comments: 18920,
    time: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20counterfeit%20cosmetics%20with%20red%20warning%20lighting%2C%20dramatic%20investigative%20atmosphere%2C%20cinematic%20noir%20photography%2C%20consumer%20fraud%20theme%2C%20dark%20shadows%2C%20professional%20composition&width=800&height=500&seq=article-cover-06&orientation=landscape',
    featured: false,
    tags: ['售假举报', '联合维权', '美妆打假'],
    author: '消费维权记者',
    content: '',
  },
  {
    id: 7,
    slug: 'zhibo-jian-ba-jia-ge-chong-tu',
    title: '两大带货主播直播间互相内涵对方卖假货，火药味十足',
    excerpt: '昨晚某平台两位头部带货主播在各自直播间隔空互怼，互相暗讽对方售卖假货，引发双方粉丝在评论区激烈互撕，场面一度失控...',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    views: 489000,
    comments: 35672,
    time: '14小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20studio%20with%20split%20screen%20showing%20dramatic%20conflict%2C%20intense%20red%20and%20blue%20contrasting%20lighting%2C%20cinematic%20photography%2C%20rivalry%20theme%2C%20dark%20atmosphere%2C%20professional%20composition&width=800&height=500&seq=article-cover-07&orientation=landscape',
    featured: false,
    tags: ['主播互怼', '带货冲突', '假货质疑'],
    author: '直播观察员',
    content: '',
  },
  {
    id: 8,
    slug: 'yinyuejie-caizi-hunwai-qing',
    title: '音乐圈才子被爆婚内出轨多人，妻子发文怒斥已起诉离婚',
    excerpt: '今日凌晨，某知名音乐人的妻子在社交平台发布长文，控诉其在婚内多次出轨，并晒出了多张聊天记录截图作为证据...',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    views: 723000,
    comments: 28934,
    time: '16小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20music%20studio%20scene%20with%20piano%20and%20scattered%20sheet%20music%2C%20dramatic%20red%20emotional%20lighting%2C%20cinematic%20noir%20photography%2C%20scandal%20theme%2C%20dark%20moody%20atmosphere%2C%20professional%20composition&width=800&height=500&seq=article-cover-08&orientation=landscape',
    featured: false,
    tags: ['婚内出轨', '妻子发文', '音乐才子'],
    author: '娱乐圈内线',
    content: '',
  },
  {
    id: 9,
    slug: 'duanshipin-daren-bei-bao-chao-xi',
    title: '短视频百万粉达人被爆长期抄袭海外博主，逐帧对比证据曝光',
    excerpt: '有网友制作了逐帧对比视频，揭示某拥有百万粉丝的短视频达人长期抄袭海外知名博主的内容，从选题到分镜几乎一模一样...',
    category: '短视频瓜',
    categorySlug: 'duanshipin-gua',
    views: 435000,
    comments: 21450,
    time: '18小时前',
    image: 'https://readdy.ai/api/search-image?query=Dark%20video%20editing%20room%20with%20split%20screens%20showing%20comparison%2C%20dramatic%20red%20and%20black%20lighting%2C%20cinematic%20photography%2C%20plagiarism%20investigation%20theme%2C%20dark%20atmosphere%2C%20professional%20composition&width=800&height=500&seq=article-cover-09&orientation=landscape',
    featured: false,
    tags: ['抄袭实锤', '逐帧对比', '搬运翻车'],
    author: '原创保护员',
    content: '',
  },
];

export const hotComments = [
  {
    id: 1,
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20profile%20silhouette%20with%20red%20glow%20accent%2C%20anonymous%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    headline: '塌房实锤中的实锤',
    comment: '这个瓜我蹲了好几天了，终于等到了实锤！那个录音我听了三遍，简直不敢相信这是平时那个温温柔柔的人说出来的话，太毁三观了。支持受害者维权！',
    identity: '第1024号吃瓜群众',
  },
  {
    id: 2,
    user: '理性吃瓜侠',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20profile%20silhouette%20with%20subtle%20blue%20glow%2C%20mysterious%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    headline: '人设崩塌教科书',
    comment: '说实话这个事情一点都不意外，之前我就觉得她太假了。一个人不可能每时每刻都那么完美，果然翻车了吧。这就是典型的人设崩塌教科书级别案例。',
    identity: '第2048号吃瓜群众',
  },
  {
    id: 3,
    user: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20profile%20silhouette%20with%20red%20flame%20glow%2C%20anonymous%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    headline: '又一个倒下的',
    comment: '今年网红翻车的也太多了吧，这才半年不到就已经十几个了。建议有关部门加强监管，这种虚假宣传和欺骗消费者的行为必须严惩不贷。',
    identity: '第4096号吃瓜群众',
  },
  {
    id: 4,
    user: '深夜不睡觉',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20profile%20silhouette%20with%20purple%20ambient%20glow%2C%20mysterious%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    headline: '天道好轮回',
    comment: '笑死，之前她粉丝还到处控评说我们造谣，现在官方都立案了看你们还怎么洗。天道好轮回，苍天饶过谁！这种人就该被封杀！',
    identity: '第8192号吃瓜群众',
  },
  {
    id: 5,
    user: '专业吃瓜二十年',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20profile%20silhouette%20with%20golden%20glow%2C%20anonymous%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 4,
    headline: '信息量好大',
    comment: '作为一名老吃瓜人，我可以负责任地说，这个瓜的信息量绝对是今年最大的。建议大家仔细看那篇长文里的每一条截图，每一条都是重磅炸弹。',
    identity: '第16384号吃瓜群众',
  },
  {
    id: 6,
    user: '今天也在摸鱼',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20profile%20silhouette%20with%20soft%20green%20glow%2C%20mysterious%20user%20avatar%20style%2C%20minimalist%20dark%20design%2C%20professional%20headshot%20style%20silhouette&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 3,
    headline: '坐等后续发展',
    comment: '先观望一下，现在双方各执一词，证据也都是一面之词。这种事情反转的太多了，说不定过两天又是一场大反转，坐等后续发展吧。',
    identity: '第32768号吃瓜群众',
  },
];

export const faqList = [
  {
    question: '17吃瓜网是什么？',
    answer: '17吃瓜是国内领先的网红八卦与娱乐黑料实时更新平台，聚合全网最新最全的吃瓜资讯，包括网红黑料、明星塌房、直播翻车、短视频瓜等丰富内容，为吃瓜群众提供一站式吃瓜入口。',
  },
  {
    question: '17吃瓜的信息来源可靠吗？',
    answer: '17吃瓜的每一条信息都经过团队多渠道交叉验证，确保信息真实可靠。我们坚持"不传谣、不信谣"的原则，对于无法核实的信息会明确标注"网传"或"待证实"标签。',
  },
  {
    question: '如何向17吃瓜爆料投稿？',
    answer: '您可以通过网站顶部的"我要爆料"按钮提交爆料信息，支持文字、图片和视频格式。我们承诺对所有爆料人信息严格保密，采用端到端加密技术保护您的隐私安全。',
  },
  {
    question: '17吃瓜有App吗？',
    answer: '目前17吃瓜App正在开发中，预计将于近期上线各大应用商店。当前您可以通过浏览器访问我们的网站，同样可以获得完整的吃瓜体验。',
  },
  {
    question: '17吃瓜网上的内容多久更新一次？',
    answer: '17吃瓜实行7×24小时全天候内容更新机制，编辑团队实时追踪全网热点，确保您随时打开都能看到最新鲜的吃瓜内容。重要事件发生后15分钟内即可看到相关报道。',
  },
];

export const brandInfo = {
  name: '17吃瓜',
  slogan: '全网热点追踪 · 网红塌房实录 · 24h独家爆料',
  description: '17吃瓜成立于2023年，是国内领先的网红八卦与娱乐黑料实时聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的吃瓜资讯，涵盖网红黑料、明星塌房、直播翻车、短视频造假、娱乐八卦等多个领域。经过三年发展，17吃瓜已成为国内最具影响力的吃瓜平台之一，日均访问用户超过500万，累计报道独家黑料超过10000篇。',
  founded: '2023年',
  visitors: '500万+',
  articles: '10000+',
  users: '3000万+',
  contact: {
    email: 'tips@17chigua.com',
    wechat: '17chigua_official',
    weibo: '@17吃瓜官方',
  },
};